export default __webpack_public_path__ + "static/media/(8).da8d19c9.jpg";